<template>
    <div class="container">
        <!--form-->
        <el-form size="mini" :inline="true" label-position="left" :label-width="queryFormLabelWidth" :model="queryForm" ref="queryForm">
            <el-form-item label="公司名称" prop="commercial_id" v-if="commercials.length > 0">
                <el-select v-model="queryForm.commercial_id" placeholder="全部" v-if="commercials.length > 1">
                    <el-option v-for="item in commercials" :label="item.name" :value="item.id" :key="item.id"></el-option>
                </el-select>
                <el-input type="text" :value="commercials[0].name" disabled v-if="commercials.length == 1"></el-input>
            </el-form-item>
            <el-form-item label="日期" prop="date">
                <el-date-picker
                        v-model="queryForm.dateRange"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        placeholder="请选择日期"
                        :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="fetchData">查询</el-button>
                <el-button @click="resetForm('queryForm')">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="line"></div>
        <el-card class="box-card mb20" style="background-color: #eaf5fc">
            <el-row>
                <el-col :span="8" v-if="$store.getters.type==1">
                    <div>
                        总收款流水
                        <div  style="display: inline-block;position: relative">
                            <el-tooltip class="item" effect="dark" content="总收款流水＝校方收款流水+公司收款流水" placement="right">
                                <i class="el-icon-warning"></i>
                            </el-tooltip>
                        </div>
                    </div>
                    <p class="red f12">＋<span class="f20 plr2">{{summary.totalCashFlow || 0}}</span>元</p>
                    <p class="c6">实际{{summary.totalOrderSum}}单 补打款{{summary.totalDebtOrderSum}}单</p>
                </el-col>
                <el-col :span="8" v-if="$store.getters.type==1">
                    <div>
                        校方收款流水
                        <div  style="display: inline-block;position: relative">
                            <el-tooltip class="item" effect="dark" content="校方收款流水：账款直接打入学校账号" placement="right">
                                <i class="el-icon-warning"></i>
                            </el-tooltip>
                        </div>
                    </div>
                    <p class="red f12">＋<span class="f20 plr2">{{summary.schoolCashFlow || 0}}</span>元</p>
                    <p class="c6">实际{{summary.schoolOrderSum}}单 补打款{{summary.schoolDebtOrderSum}}单</p>
                </el-col>
                <el-col :span="8">
                    <div>
                        公司收款流水
                        <div  style="display: inline-block;position: relative">
                            <el-tooltip class="item" effect="dark" content="户收款流水：账款打入公司账号" placement="right">
                                <i class="el-icon-warning"></i>
                            </el-tooltip>
                        </div>
                    </div>
                    <p class="red f12">＋<span class="f20 plr2">{{summary.commercialCashFlow || 0}}</span>元</p>
                    <p class="c6">实际{{summary.commercialOrderSum}}单 补打款{{summary.commercialDebtOrderSum}}单</p>
                </el-col>
            </el-row>
        </el-card>
        <el-row class="pb20">
            <!--<div>-->
                <!--<el-button type="primary" @click="exportExcel()">导出</el-button>-->
                <!--<form name="downForm" method="get"></form>-->
            <!--</div>-->
            <export-excel :params="exportParams" :action="tableDataUrl" :target="'finance'" :field="field" :filename="fileName" :fieldname="fieldName"></export-excel>
        </el-row>

        <!--table-->
        <el-table
                v-loading="loading"
                :data="tableData"
                border
                style="width: 100%">
            <el-table-column
                    prop="num"
                    label="序号"
                    width="70">
            </el-table-column>
            <el-table-column
                    prop="businessDate"
                    label="日期"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="commercialName"
                    label="公司名称"
                    :show-overflow-tooltip="true"
                    width="160">
            </el-table-column>
            <el-table-column
                    prop="totalBillAmount"
                    label="收入金额（元）"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="totalOrderSum"
                    label="实际订单数"
                    width="110">
            </el-table-column>
            <el-table-column
                    prop="totalDebtOrderSum"
                    label="补打款订单数"
                    width="110">
            </el-table-column>
            <el-table-column
                prop="expenseAmount"
                label="退款金额（元）"
                width="110">
            </el-table-column>
            <el-table-column
                prop="expenseSum"
                label="实际退款订单数"
                width="110">
            </el-table-column>
            <el-table-column
                prop="realIncomeAmount"
                label="收入金额（剔除退款）"
                width="150">
            </el-table-column>
            <el-table-column
                prop="realOrderSum"
                label="实际订单数（剔除退款）"
                width="160">
            </el-table-column>
            <el-table-column
                    v-if="!$route.params.vid "
                    prop="payType"
                    label="打款方式"
                    width="90">
                <template slot-scope="scope">
                    <span v-if="scope.row.payType === 1">财务转账</span>
                    <span v-else-if="scope.row.payType === 2">支付宝</span>
                    <span v-else-if="scope.row.payType === 3">银联转账</span>
                    <span v-else-if="scope.row.payType === 5">支付宝直付通打款</span>
                    <span v-else-if="scope.row.payType === 6">快钱打款</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="checkOutType"
                    label="收款方式"
                    width="">
                <template slot-scope="scope">
                    {{ scope.row.checkOutType == 1 ? '学校' : scope.row.checkOutType == 2 ? '公司' : '' }}
                </template>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="操作"
                    fixed="right"
                    width="100">
                <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="view(scope.row)">查看</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--pagination-->
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryForm.pageNo"
                :page-sizes="pageSizes"
                :page-size="queryForm.pageSize"
                layout="sizes, prev, next"
                prev-text="上一页"
                next-text="下一页">
        </el-pagination>
    </div>
</template>

<script>
    import moment from 'moment'
    import ExportExcel from "../../components/exportExcel2.vue";
    export default {
        components: {ExportExcel},
        data() {
            let vue = this;
            return {
                queryFormLabelWidth: '100px',//自定义查询表单label宽度
                queryForm: {//查询表单数据
                    pageSize: 10,
                    pageNo: 1,
                    startDate: '',
                    endDate: '',
                    dateRange: [],
                    commercial_id: '',
                    for_report: true
                },

                tableData: [],//表格数据
                // total: 0,//总数
                pageSizes: [10,20,30,40,50],//自定义分页条数
                multipleSelection: [],//table选中项
                loading: true,//表格是否显示加载效果

                commercials: [],
//                shops: [],
                summary: {},

                //导出
                exportParams: {},
                fileName: '公司数据表',
                fieldName: ['序号','日期','公司名称','收入金额（元）','实际订单数','补打款实际订单数','退款金额（元）','实际退款订单数','收入金额（剔除退款）','实际订单数（剔除退款）','收款方式'],
                field: ['num','businessDate','commercialName','totalBillAmount','totalOrderSum','totalDebtOrderSum','expenseAmount','expenseSum','realIncomeAmount','realOrderSum','checkOutType'],
                pickerOptions: {
                    disabledDate(time) {
                        let timeOptionRange = vue.timeOptionRange;
                        let secondNum = 30 * 60 * 60 * 24 * 1000;
                        if (timeOptionRange) {
                            return time.getTime() > timeOptionRange.getTime() + secondNum || time.getTime() < timeOptionRange.getTime() - secondNum;
                        }
                    },
                    onPick(time) {
                        //当第一时间选中才设置禁用
                        if (time.minDate && !time.maxDate) {
                            vue.timeOptionRange = time.minDate;
                        }
                        if (time.maxDate) {
                            vue.timeOptionRange = null;
                        }
                    }
                },

                tableDataUrl: ''
            }
        },
        created(){
            //默认显示最近一周
            var day = new Date();
            day.setTime(day.getTime()-7*24*60*60*1000);
            this.queryForm.dateRange = [day,new Date()];
            this.commercials = JSON.parse(localStorage.getItem('commercials'));
            this.tableDataUrl = this.$apiUrl.financeMerchantBill;
            if (this.$route.params.vid === 'v2') {
                this.tableDataUrl += '/v2';
            };
            this.fetchData();
        },
        methods: {
            //抓取列表数据
            fetchData() {
                this.getSummary();
                this.getTableData();
            },
            getParams() {
                let params = {...this.queryForm};
                params.startDate = moment(params.dateRange[0]).format('YYYYMMDD');
                params.endDate = moment(params.dateRange[1]).format('YYYYMMDD');
                delete params.dateRange;
                return params;
            },
            getSummary() {
                let params = this.getParams();
                delete params.pageSize;
                delete params.pageNo;
                this.$apiJava.post(this.$apiUrl.financeMerchantBillSummary,params,(res)=>{
                    this.summary = res.data;
                },null,'finance')
            },
            getTableData() {
                let params = this.getParams();

                this.exportParams = {...params};
                this.exportParams.pageNo = 1;
                this.exportParams.pageSize = 99999;
                this.$apiJava.post(this.tableDataUrl,params,(res)=>{
                    this.loading = false;
                    // this.total = res.data.total || 0;
                    this.tableData = res.data.list || [];
                },(res)=>{
                    this.$message.warning(res.message);
                    this.loading = false;
                    this.tableData = [];
                },'finance')
            },
            //查看
            view(item) {
                this.$router.push({path:'/finance/shop/bill/1005',query: { id: `${item.commercialId}`, date: `${item.businessDate}`}})
            },
            //表单重置 item上需要添加prop属性
            resetForm(formName) {
                this.$refs[formName].resetFields();
//                this.queryForm.dateRange = [];
            },
            //切换每页显示条数操作
            handleSizeChange(val) {
                this.queryForm.pageSize = val;
                this.getTableData();
            },
            //切换页码操作
            handleCurrentChange(val) {
                this.queryForm.pageNo = val;
                this.getTableData();
            }
        }
    }
</script>
<style lang="scss"  scoped>
    .el-card{
        border: none;
        box-shadow: none;
    }
</style>



// WEBPACK FOOTER //
// merchant.vue?51e3b480